import { useState } from 'react';

import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { ServiceLayer } from '@packages/modules/src/ServiceLayer/ServiceLayer.client';

export type ServiceLayerData = {
  header: string;
  serviceLayerId: string;
};

export const useServiceLayer = () => {
  const [dialogContent, setDialogContent] = useState<ServiceLayerData | null>(null);

  let serviceLayer = null;

  if (dialogContent !== null) {
    const handleDialogClose = () => {
      setDialogContent(null);
    };

    serviceLayer = (
      <Dialog isOpen onClose={handleDialogClose} variant="bottomSheet">
        <DialogHeader onClose={handleDialogClose}>{dialogContent.header}</DialogHeader>
        <DialogContent>
          <ServiceLayer serviceLayerId={dialogContent.serviceLayerId} />
        </DialogContent>
      </Dialog>
    );
  }

  return {
    setDialogContent,
    serviceLayer,
  };
};
